import {
  useMutation,
  UseMutationOptions,
  useQuery,
} from "@tanstack/react-query"
import type { FAQ, Prisma } from "@tfg/db"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { i18n } from "~/i18n"

export const useFAQQuery = () => {
  return useQuery<FAQ[]>({
    queryKey: ["faq"],

    queryFn: async () => {
      const lang = i18n.language.split("-")[0].toUpperCase()
      const response = await httpClient.get(`faq`, {
        params: {
          lang,
        },
      })
      return response.data
    },
  })
}

export const useCreateFAQMutation = (
  options?: UseMutationOptions<FAQ, AxiosError, Prisma.FAQCreateInput>
) => {
  return useMutation<FAQ, AxiosError, Prisma.FAQCreateInput>({
    mutationKey: ["faq"],

    mutationFn: async (variables) => {
      const response = await httpClient.post(`faq`, variables)
      return response.data
    },

    ...options,

    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({ queryKey: ["faq"] })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}

export const useEditFAQMutation = (
  faqId?: string,
  options?: UseMutationOptions<FAQ, AxiosError, Prisma.FAQUpdateInput>
) => {
  return useMutation<FAQ, AxiosError, Prisma.FAQUpdateInput>({
    mutationKey: ["faq"],

    mutationFn: async (variables) => {
      const response = await httpClient.put(`faq/${faqId}`, variables)
      return response.data
    },

    ...options,

    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({ queryKey: ["faq"] })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
